import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type RightPanelCloseProps = IconComponentBaseProps;

export const RightPanelClose = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: RightPanelCloseProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_4893_41827"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4893_41827)">
        <path
          d="M6.62699 12.0848C6.62699 12.2579 6.70366 12.3764 6.85699 12.4405C7.01033 12.5046 7.14838 12.4753 7.27116 12.3523L9.09658 10.5271C9.24713 10.3764 9.32241 10.2007 9.32241 9.99984C9.32241 9.799 9.24713 9.62324 9.09658 9.47255L7.27116 7.64734C7.14838 7.52442 7.01033 7.49505 6.85699 7.55921C6.70366 7.62324 6.62699 7.74178 6.62699 7.91484V12.0848ZM4.42345 17.0832C4.0079 17.0832 3.6529 16.936 3.35845 16.6417C3.06415 16.3473 2.91699 15.9923 2.91699 15.5767V4.42296C2.91699 4.00741 3.06415 3.65241 3.35845 3.35796C3.6529 3.06366 4.0079 2.9165 4.42345 2.9165H15.5772C15.9928 2.9165 16.3478 3.06366 16.6422 3.35796C16.9365 3.65241 17.0837 4.00741 17.0837 4.42296V15.5767C17.0837 15.9923 16.9365 16.3473 16.6422 16.6417C16.3478 16.936 15.9928 17.0832 15.5772 17.0832H4.42345ZM13.3337 15.8332H15.8337V4.42296C15.8337 4.3588 15.8069 4.30005 15.7535 4.24671C15.7001 4.19324 15.6414 4.1665 15.5772 4.1665H13.3337V15.8332ZM12.0837 15.8332V4.1665H4.42345C4.35928 4.1665 4.30053 4.19324 4.2472 4.24671C4.19373 4.30005 4.16699 4.3588 4.16699 4.42296V15.5767C4.16699 15.6409 4.19373 15.6996 4.2472 15.753C4.30053 15.8064 4.35928 15.8332 4.42345 15.8332H12.0837Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
